import React from "react";

const dischargeCategories = [
  {
    section: "(i) To Surface water",
    subcategory: "No treatment",
    key: "surface",
    subkey: "noTreatment",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(i) To Surface water",
    subcategory: "With treatment",
    key: "surface",
    subkey: "withTreatment",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },

  {
    section: "(ii) To Groundwater",
    subcategory: "No treatment",
    key: "groundwater",
    subkey: "noTreatment",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(ii) To Groundwater",
    subcategory: "With treatment",
    key: "groundwater",
    subkey: "withTreatment",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  // Seawater
  {
    section: "(iii) To Seawater",
    subcategory: "No treatment",
    key: "seawater",
    subkey: "noTreatment",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iii) To Seawater",
    subcategory: "With treatment",
    key: "seawater",
    subkey: "withTreatment",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  // Third-party
  {
    section: "(iv) Sent to third-parties",
    subcategory: "No treatment",
    key: "thirdparty",
    subkey: "noTreatment",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(iv) Sent to third-parties",
    subcategory: "With treatment",
    key: "thirdparty",
    subkey: "withTreatment",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  // Others
  {
    section: "(v) Others",
    subcategory: "No treatment",
    key: "others",
    subkey: "noTreatment",
    label: "• No treatment",
    current: "",
    previous: "",
  },
  {
    section: "(v) Others",
    subcategory: "With treatment",
    key: "others",
    subkey: "withTreatment",
    label: "• With treatment – please specify level of treatment",
    current: "",
    previous: "",
  },
  // Total
  {
    section: "",
    subcategory: "",
    key: "totalDischarge",
    subkey: "",
    label: "Total water discharged (in kilolitres)",
    current: "",
    previous: "",
  },
];

const WaterDischargeTreatmentTable = ({
  dischargeData = [],
  setDischargeData,
}) => {
  const flatData =
    dischargeData.length > 0 ? dischargeData : dischargeCategories;

  const handleChange = (index, field, value) => {
    const updated = [...flatData];
    updated[index][field] = value;
    setDischargeData(updated);
  };

  const groupedData = flatData.reduce((acc, row, idx) => {
    const section = row.section || "Total";
    if (!acc[section]) acc[section] = [];
    acc[section].push({ ...row, index: idx });
    return acc;
  }, {});

  return (
    <div
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={cellHeaderNarrow}>Parameter</th>
            <th style={cellHeader}>
              FY _____
              <br />
              Current Financial Year
            </th>
            <th style={cellHeader}>
              FY _____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3} style={sectionStyle}>
              Water discharge by destination and level of treatment (in
              kilolitres)
            </td>
          </tr>

          {Object.entries(groupedData).map(([section, rows]) => (
            <React.Fragment key={section}>
              {section !== "Total" && (
                <tr>
                  <td colSpan={3} style={subSectionStyle}>
                    {section}
                  </td>
                </tr>
              )}
              {rows.map((row) => (
                <tr key={`${row.key}-${row.subkey}`}>
                  <td style={labelCell}>{row.label}</td>
                  <td style={inputCell}>
                    <input
                      type="text"
                      placeholder="Current FY"
                      value={row.current}
                      onChange={(e) =>
                        handleChange(row.index, "current", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                  <td style={inputCell}>
                    <input
                      type="text"
                      placeholder="Previous FY"
                      value={row.previous}
                      onChange={(e) =>
                        handleChange(row.index, "previous", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const cellHeader = {
  border: "1px solid #000",
  padding: "15px",
  textAlign: "center",
  backgroundColor: "#d3c9ce",
};

const cellHeaderNarrow = {
  ...cellHeader,
  width: "30%",
};

const sectionStyle = {
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  padding: "15px",
  border: "1px solid #000",
  textAlign: "center",
};

const subSectionStyle = {
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
};

const labelCell = {
  border: "1px solid #000",
  padding: "15px",
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  textAlign: "left",
  verticalAlign: "top",
  height: "80px",
  lineHeight: "1.4",
};

const inputCell = {
  border: "1px solid #000",
  padding: "15px",
  backgroundColor: "#fff",
  verticalAlign: "middle",
  textAlign: "center",
  minHeight: "80px",
};

const inputStyle = {
  width: "80%",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
  outline: "none",
};

export default WaterDischargeTreatmentTable;
